import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('elitebet_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      api.verifyToken(token)
        .then(data => {
          if (data.valid) {
            setAdmin(data.admin);
          } else {
            logout();
          }
        })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    const data = await api.login(email, password);
    if (data.token) {
      localStorage.setItem('elitebet_token', data.token);
      setToken(data.token);
      setAdmin(data.admin);
      return { success: true };
    }
    return { success: false, error: data.error };
  };

  const register = async (email, password) => {
    const data = await api.register(email, password);
    if (data.token) {
      localStorage.setItem('elitebet_token', data.token);
      setToken(data.token);
      setAdmin(data.admin);
      return { success: true };
    }
    return { success: false, error: data.error };
  };

  const logout = () => {
    localStorage.removeItem('elitebet_token');
    setToken(null);
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, token, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
